export const RAIL360_SUPPORTED_COMPONENTS = [
  'stack',
  'grid',
  'text',
  'callout',
  'badge',
  'statCard',
  'table'
] as const;
